import React, { useEffect, useState } from 'react';
import { availableTimeSlots } from '../../services/EventService';
import DropDownSelector from './DropDownSelector';
import { convertTimeIntoMinutes } from '../../services/Helper';
import moment from 'moment';

interface DropDownSelectorAvailableTimesProps {
  selectedDate: Date | null;
  startTime: number;
  duration: number;
  category: string;
  audience: number;
  onTimeSelect: (time: number) => void;
}

const DropDownSelectorAvailableTimes: React.FC<DropDownSelectorAvailableTimesProps> = ({
  selectedDate,
  startTime,
  duration,
  category,
  audience,
  onTimeSelect,
}) => {
  const [availableTimes, setAvailableTimes] = useState<string[]>([]);

  useEffect(() => {
    if (selectedDate) {
      fetchAvailableTimeSlots();
    }
  }, [selectedDate, duration]);

  const fetchAvailableTimeSlots = async () => {
    try {
      const input = {
        duration: duration,
        liveBookingDate: selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : undefined,
        category: category,
        audience: audience
      };
      
      const { data } = await availableTimeSlots(0, input);
      if (data?.availableTimeSlots?.statusCode === 200) {
        setAvailableTimes(data.availableTimeSlots.data);
      }
    } catch (error) {
      console.error('Error fetching time slots:', error);
    }
  };

  return (
    <DropDownSelector
      label="Available Times"
      currentId={startTime}
      items={availableTimes.map((time) => ({
        id: convertTimeIntoMinutes(time),
        name: time
      }))}
      handleCurrentId={(event) => onTimeSelect(Number(event))}
    />
  );
};

export default DropDownSelectorAvailableTimes; 